import { useMemo, useState } from 'react'

const DEFAULT_TEXT = `世界很大
有你就好`
const FONT_FAMILY = '"YouAreEnoughCN", "Noto Serif CJK SC", "Source Han Serif SC", serif'

export default function FontPreview() {
  const [value, setValue] = useState(DEFAULT_TEXT)
  const lines = useMemo(() => (value || DEFAULT_TEXT).split('\n'), [value])
  const meta = useMemo(() => (value || DEFAULT_TEXT).replace(/\n/g, ' / '), [value])

  return (
    <div className="mx-auto max-w-5xl space-y-6">
      <header className="space-y-2 text-center">
        <h1 className="text-3xl font-bold text-cocoa">中文字体预览</h1>
        <p className="text-cocoa-light">输入任意中文，直接查看字形效果。</p>
      </header>

      <section className="space-y-3">
        <label htmlFor="font-sample" className="text-sm font-medium text-cocoa-light">
          输入你想看的字
        </label>
        <textarea
          id="font-sample"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          spellCheck="false"
          className="form-input min-h-28 resize-y rounded-2xl bg-white/80 font-sans text-lg leading-8"
        />
      </section>

      <section className="rounded-2xl border border-blush/30 bg-white/70 p-6 shadow-card sm:p-8">
        <div
          className="space-y-4 text-center text-cocoa"
          style={{
            fontFamily: FONT_FAMILY,
            fontSize: 'clamp(48px, 8vw, 120px)',
            lineHeight: 1.25,
            letterSpacing: 0,
            wordBreak: 'keep-all',
            whiteSpace: 'pre-wrap',
          }}
        >
          {lines.map((line, index) => (
            <div key={`${index}-${line}`}>{line || '\u00a0'}</div>
          ))}
        </div>
        <p className="mt-6 text-center text-sm text-cocoa-light">文字：{meta}</p>
      </section>
    </div>
  )
}
